import { Component, ViewChild } from '@angular/core';
import { App, NavController, NavParams, LoadingController, Events } from 'ionic-angular';
import { HomePage } from '../home/home';
import { ApiService } from '../../api-service/api-service';

import { User,UserPost } from '../../providers/providers';

import { Camera, CameraOptions } from '@ionic-native/camera';
import { Toast } from 'ionic-angular/components/toast/toast';
import { ToastController } from 'ionic-angular';

declare var AWS: any;
declare const aws_user_files_s3_bucket;
declare const aws_user_files_s3_bucket_region;

const url = 'https://cdn.chitika.net/getads.js';

@Component({
  templateUrl: 'post-pic.html'
})
export class PostPicPage {
  @ViewChild('postPicInput') postPicInput;
  public homePage = HomePage;
  message = "";
  picURL = "";
  category = "";
  userName = "";
  picFileName = "";
  picKey = "";
  public showPhoto = true;
  public userPost:UserPost;
  public postPhoto: string;
  private s3: any;
  public avatarPhoto: string;
  public selectedPhoto: Blob;
  public sub: string = null;

  loadAPI: Promise<any>;
  public placement_id:number;
  public bannerId:string = "not set";
  

  constructor(public server:ApiService, 
    public navCtrl: NavController,
    public navParams:NavParams,
    public user: User,
    public camera: Camera,
    public loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    public events:Events) {
      
      let test = "hit the code";
      this.postPhoto = null;
      if (navParams.get('userPost')){
          this.userPost = navParams.get('userPost');
      }
      //this.userPost = new UserPost(user.getUsername());
      this.selectedPhoto = null;
      this.s3 = new AWS.S3({
        'params': {
          'Bucket': aws_user_files_s3_bucket
        },
        'region': aws_user_files_s3_bucket_region
      });
      
  }

  chitikaAddHeight(){
    if (window['CHITIKA'] === undefined) { window['CHITIKA'] = { 'units' : [] }; };
          var unit = {"calltype":"async[2]","publisher":"picladder","width":320,"height":50,"sid":"Chitika Default"};
          this.placement_id = window['CHITIKA'].units.length;
          window['CHITIKA'].units.push(unit);
          this.bannerId = "chitikaAdBlock-"+this.placement_id.toString();
          //document.write('<div id="chitikaAdBlock-' + this.placement_id + '"></div>');
  }

  ngAfterViewInit(){
    this.loadAPI = new Promise((resolve) => {
        console.log('resolving promise...');
        this.loadScript();
    }).catch((err)=>{
      let t = err;
      console.log(t);
    });
}



public loadScript() {
    console.log('preparing to load...')
    let node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    node.async = true;
    node.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(node);
    this.chitikaAddHeight();
}



  cancel(){
      this.navCtrl.pop();
  }

  postPic(){
    //this.userName = this.user.getUsername();
    //let postData = new UserPost(
    //  this.category, this.userName
    //);
    let avatarURL = "https://s3-us-west-2.amazonaws.com/picladder-userfiles-mobilehub-1474428011/protected/"+ this.sub + "/avatar";
    let avatarKey = "protected/"+ this.sub + "/avatar";
    this.userPost.avatarKey = avatarKey;
    this.userPost.avatarURL = avatarURL;
    this.userPost.message = this.message;
    this.userPost.votes = 0;
    //this.userPost.userName = this.userName;
    this.picURL = "https://s3-us-west-2.amazonaws.com/picladder-userfiles-mobilehub-1474428011/protected/"+ this.sub + "/posts/"+this.picFileName; 
    this.userPost.picURL = this.picURL;
    this.userPost.picKey = this.picKey;
    this.server.postPic(this.userPost, this.postPicCallback);
  }

  //Fat arrow used to keep scope, private entry back in
  public postPicCallback = (comments) => {
    this.backToLadder();
  }

  backToLadder(){
    this.events.publish("PostAdded:"+this.userPost.category, this.userPost);
    this.navCtrl.pop();
  }
  
  dataURItoBlob(dataURI) {
    // code adapted from: http://stackoverflow.com/questions/33486352/cant-upload-image-to-aws-s3-from-ionic-camera
    let binary = atob(dataURI.split(',')[1]);
    let array = [];
    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], {type: 'image/jpeg'});
  };

  selectPic() {
    const options: CameraOptions = {
      quality: 100,
      targetHeight: 300,
      targetWidth: 300,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE
    }

    this.sub = AWS.config.credentials.identityId;

    this.camera.getPicture(options).then((imageData) => {
      // imageData is either a base64 encoded string or a file URI
      // If it's base64:
      this.selectedPhoto  = this.dataURItoBlob('data:image/jpeg;base64,' + imageData);
      this.upload();
    }, (err) => {
      this.postPicInput.nativeElement.click();
      // Handle error
    });
  }

  uploadFromFile(event) {
    const files = event.target.files;
    console.log('Uploading', files)
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = () => {
      this.selectedPhoto = this.dataURItoBlob(reader.result);
      this.upload();
    };
    reader.onerror = (error) => {
      alert('Unable to load file. Please try another.')
    }
  }

  refreshPic() {
    //this.s3.getSignedUrl('getObject', {'Key': 'protected/' + this.sub + '/posts'+this.picFileName}, (err, url) => {
    this.s3.getSignedUrl('getObject', {'Key': this.picKey}, (err, url) => {
      this.postPhoto = url;
    });
  }

  upload() {
    let loading = this.loadingCtrl.create({
      content: 'Uploading image...'
    });
    loading.present();
    this.picFileName = "Post"+new Date().toISOString()+".jpg";
    this.picKey = "protected/" + this.sub + "/posts/"+this.picFileName;
    if (this.selectedPhoto) {
      this.s3.upload({
        "Key": "protected/" + this.sub + "/posts/"+this.picFileName,
        //'Key': 'uploads/test.jpg',
        "Body": this.selectedPhoto,
        "ContentType": "image/jpeg"
      }).promise().then((data) => {
        this.refreshPic();
        console.log('upload complete:', data);
        loading.dismiss();
      }, err => {
        console.log('upload failed....', err);
        
        let toast = this.toastCtrl.create({
          message: 'Error Saving Picture!',
          duration: 3000,
          position: 'top'
        });
      
        toast.onDidDismiss(() => {
          console.log('Dismissed toast');
        });    
        toast.present();
        loading.dismiss();
      });
    } else {
      loading.dismiss();
    }
  }
  /*runNewModel(){
    let runParams = new ModelParameters(this.latitude,this.longitude,
        this.cloudCover,this.startTime,this.spillHeight,this.spillRate);
    this.server.runNewModel(runParams, this.navCtrl);
    //this.server.runNewModel();
    this.server.results;
  }*/

  /*
Hello,
I am having a very hard time getting the debugger to step through a lambda function when running as api gateway local.  I am trying to test a post with json data in the payload post body.  When I click the run button with the debug leaf on it will either just hand forever or immediately return like it never ran show the empty values:
Response


Response Headers


HTTP Logs
I have break points set immedately.  I created this from the node.js microservice template, I had created some previously and was able to step through but now it is stuck on all functions never debugging api gateways local.  Does anyone have any suggestions?

Thanks,
  */

}


// WEBPACK FOOTER //
// ./src/pages/post-pic/post-pic.ts